import { TGranularity } from '@intelligence/services/marketProfile';
import { sortTime } from '../../_util';
import moment from 'moment';

type SourceItem = {
  date: string;
  market: string;
  metric: 'revenue' | 'download';
  source: string;
  value: number;
  value_ratio: number;
};

type TargetItem = {
  date: string;
  digtal_rev: number;
  downLoad: number;
  physical_rev: number;
  rev: number;
};

// sensortower 转换函数, 转换趋势图
export function trans2MarketTrendData(source: SourceItem[]): TargetItem[] {
  if (!source?.length) return [];

  const groupedData = source.reduce((acc, item) => {
    if (!acc[item.date]) {
      acc[item.date] = {
        date: item.date,
        digtal_rev: 0,
        downLoad: 0,
        physical_rev: 0,
        rev: 0,
      } as TargetItem;
    }

    // 根据 metric 填充对应字段
    if (item.metric === 'revenue') {
      acc[item.date].rev = item.value;
    } else if (item.metric === 'download') {
      acc[item.date].downLoad = item.value;
    }

    return acc;
  }, {} as Record<string, TargetItem>);

  // const resArr = Object.values(groupedData).sort(
  //   (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
  // );

  const resArr = Object.values(groupedData).sort(sortTime('date'));

  return resArr;
}

interface IMetricItem {
  date: string;
  downLoad: number;
  digtal_rev: number;
  physical_rev: number;
  rev: number;
}

// TODO: mobile_summary_date 历史遗留 BUG
export function totalMarketMobileCardHistoryPatch(data: IMetricItem[]) {
  const res = data?.map((i) => {
    return {
      ...i,
      digtal_rev: i?.rev,
    };
  });

  return res;
}

type SourceRankItem = {
  data_source: string;
  link_rank: number;
  metric: 'download' | 'revenue';
  rank: number;
  value_dod: string;
};

type StoreStats = {
  rev_total?: number;
  downLoad_total?: number;
  pre_rev_total?: number;
  pre_download_total?: number;
  digtal_rev_total?: number;
  physical_rev_total?: number;
  pre_digtal_rev_total?: number;
  pre_physical_rev_total?: number;
  rev_rank: number;
  pre_rev_rank: number;
  dl_rank: number;
  pre_dl_rank: number;
};

// sensortower 转换函数, 榜单排名
export function trans2MobileMarketRankData(source: SourceRankItem[]): StoreStats {
  const result: StoreStats = {
    rev_total: 0,
    downLoad_total: 0,
    pre_rev_total: 0,
    pre_download_total: 0,
    digtal_rev_total: 0,
    physical_rev_total: 0,
    pre_digtal_rev_total: 0,
    pre_physical_rev_total: 0,
    rev_rank: 0,
    pre_rev_rank: 0,
    dl_rank: 0,
    pre_dl_rank: 0,
  };

  source?.forEach((item) => {
    if (item.metric === 'revenue') {
      result.rev_rank = item.rank;
      result.pre_rev_rank = item.link_rank;
    } else if (item.metric === 'download') {
      result.dl_rank = item.rank;
      result.pre_dl_rank = item.link_rank;
    }
  });

  return result;
}

// detail/ stats / operation data tab

export interface IOperationParams {
  market: string;
  entity_type: string;
  genre: any[];
  data_tag: string;
  start_date: string;
  end_date: string;
  page: number;
  page_size: number;
  order: string;
  order_by: string;
  granularity: string;
  iegg_genre_req?: any[];
  dataSource: string;
  is_annie: boolean;
}

export interface IMetricsParams {
  source_metrics: Record<string, string[]>;
  granularity: TGranularity;
  regions: string[];
  platforms: string[];
  metrics: string[];
  genres: string[];
  b_growth_ratio: boolean;
  b_group_by_date: boolean;
  b_group_by_market: boolean;
  start_date: string;
  end_date: string;
}

export function transOperation2SensorParams(params: IOperationParams): IMetricsParams {
  // 数据源到指标的映射
  const { dataSource, market, granularity, genre, start_date, end_date } = params;

  const metrics = ['revenue', 'download'];

  return {
    // ...params,
    source_metrics: {
      [dataSource]: metrics,
    },
    metrics,
    granularity: granularity as TGranularity,
    regions: [market],
    platforms: ['All'],
    genres: genre?.length > 0 ? genre : [],
    b_growth_ratio: true,
    b_group_by_date: true,
    b_group_by_market: true,
    start_date,
    end_date,
  };
}

export interface IOperationDataItem {
  metric: string;
  date: string;
  market: string;
  value: number;
  value_ratio: number;
  source: string;
}

export interface ITargetOperatioItem {
  date: string;
  rev: number;
  download: number;
  pre_rev: number;
  pre_dl: number;
  digtal_rev: number;
  physical_rev: number;
  pre_digtal_rev: number;
  pre_physical_rev: number;
}

export interface ITargetOutput {
  total_size: number;
  opreatio_rank: ITargetOperatioItem[];
  pre_opreatio_rank: ITargetOperatioItem[];
  start_date: string;
  end_date: string;
}

export function transOperation2SensorOutput({
  originalData,
  granularity,
}: {
  originalData: IOperationDataItem[];
  granularity?: TGranularity;
}): ITargetOutput {
  // 按日期合并 revenue 和 download 数据
  const mergedData = originalData?.reduce((acc, item) => {
    const key = item.date;
    if (!acc[key]) {
      acc[key] = { date: key, rev: 0, download: 0, rev_ratio: 0, download_ratio: 0 };
    }
    if (item.metric === 'revenue') {
      acc[key].rev = item.value;
      acc[key].rev_ratio = item.value_ratio;
    } else if (item.metric === 'download') {
      acc[key].download = item.value;
      acc[key].download_ratio = item.value_ratio;
    }
    return acc;
  }, {} as Record<string, any>);

  // 生成 opreatio_rank
  const opreatioRank = Object?.values(mergedData).map((item) => ({
    date: item.date,
    rev: item.rev,
    download: item.download,
    pre_rev: item.rev_ratio,
    pre_dl: item.download_ratio,
    digtal_rev: 0,
    physical_rev: 0,
    pre_digtal_rev: 0,
    pre_physical_rev: 0,
  }));

  // 生成 pre_opreatio_rank（前一个周期数据，但需后面补一个数据）
  const preOpreatioRank = opreatioRank
    ?.map((item) => {
      // const prevDate = getPreviousMonth(item.date);
      const prevDate = getPreviousPeriod({
        dateStr: item?.date,
        granularity: granularity as TGranularity,
      });

      return {
        date: prevDate,
        // date: item.date,
        rev: 0,
        download: 0,
        pre_rev: item.pre_rev,
        pre_dl: item.pre_dl,
        digtal_rev: 0,
        physical_rev: 0,
        pre_digtal_rev: 0,
        pre_physical_rev: 0,
      };
    })
    // 特殊处理，对应出参格式
    ?.concat(
      [opreatioRank?.[opreatioRank?.length - 1]]?.map((i) => {
        return {
          date: i?.date,
          rev: 0,
          download: 0,
          pre_rev: i?.rev,
          pre_dl: i?.download,
          digtal_rev: 0,
          physical_rev: 0,
          pre_digtal_rev: 0,
          pre_physical_rev: 0,
        };
      }),
    );

  // 获取日期范围
  // const dates = Object.keys(mergedData).sort(sortTime('date'));
  const dates = Object.keys(mergedData).sort();
  const [start_date, end_date] = dates.length > 0 ? [dates[0], dates[dates.length - 1]] : ['', ''];

  return {
    total_size: 0,
    opreatio_rank: opreatioRank,
    pre_opreatio_rank: preOpreatioRank,
    start_date,
    end_date,
  };
}

export function getPreviousPeriod({
  dateStr,
  granularity,
}: {
  dateStr: string;
  granularity: TGranularity;
}): string {
  const unitMap = {
    daily: 'days',
    weekly: 'weeks',
    monthly: 'months',
  };

  if (!(granularity in unitMap)) {
    throw new Error(`Invalid granularity type: ${granularity}`);
  }

  // @ts-ignore
  return moment(dateStr)?.add(-1, unitMap[granularity]).format('YYYY-MM-DD');
}

export function replaceRankDates({ rankParams, newCurDate, newLastDate }) {
  return {
    ...rankParams,
    start_time: newCurDate,
    end_time: newLastDate,
    rank_date_map: rankParams?.rank_date_map.map((item) => ({
      ...item,
      cur_date: newCurDate,
      last_date: newLastDate,
    })),
  };
}

interface ITransformedGenresParams {
  source_metrics: Record<string, string[]>;
  granularity: TGranularity;
  regions: string[];
  platforms: string[];
  metrics: string[];
  genres: string[];
  b_growth_ratio: boolean;
  b_group_by_date: boolean;
  b_group_by_market: boolean;
  b_group_by_genre: boolean;
  start_date: string;
  end_date: string;
}

interface IOriginalGenresParams {
  market: string;
  entity_type: string;
  start_date: string;
  end_date: string;
  source: string;
}

export function trans2SensorGenresParams(params: IOriginalGenresParams): ITransformedGenresParams {
  const { market, source, start_date, end_date } = params;

  return {
    source_metrics: {
      [source]: ['revenue'],
    },
    granularity: 'monthly',
    regions: [market],
    platforms: ['All'],
    metrics: ['revenue'],
    genres: [],
    b_growth_ratio: true,
    b_group_by_date: true,
    b_group_by_market: false,
    b_group_by_genre: true,
    start_date: start_date ? moment(start_date).add(-5, 'month').format('YYYY-MM-DD') : '',
    end_date,
  };
}

//
interface IGenreSourceItem {
  metric: string;
  date: string;
  genre: string;
  value: number;
  value_ratio: number;
  source: string;
}

interface MarketTopGenre {
  name: string;
  children: Array<{ Name: string; Value: number }>;
  name_rev: number;
}

interface DailyRevenue {
  name: string;
  rev: number;
}

interface TargetData {
  market_top_genre: MarketTopGenre[];
  top_genre_rev_daily: Array<{
    name_rev: DailyRevenue[];
    date: string;
    rev_total: number;
  }>;
  rev_total: number;
  start_date: string;
  end_date: string;
  init: number;
}

export function trans2MobileTopGenre(source: IGenreSourceItem[]): TargetData {
  const genreSet = new Set<string>();
  const dateMap = new Map<string, Map<string, number>>();
  const genreTotalMap = new Map<string, number>();

  source
    ?.filter((sItem) => sItem?.genre !== 'All')
    ?.forEach((item) => {
      genreSet.add(item.genre);

      if (!dateMap.has(item.date)) {
        dateMap.set(item.date, new Map());
      }
      dateMap.get(item.date)!.set(item.genre, item.value);

      // 累计各类型总收入
      genreTotalMap.set(item.genre, (genreTotalMap.get(item.genre) || 0) + item.value);
    });

  const marketTopGenre = Array.from(genreSet)
    // ?.filter((g) => g !== 'All')
    ?.map((genre) => {
      const months = Array.from(dateMap?.keys());
      const lastMonth = months?.[months?.length - 1];
      const findNameRev = dateMap?.get(lastMonth)?.get(genre);

      // console.log('top genre market', {
      //   genre,
      //   genreSet,
      //   genreTotalMap,
      //   dateMap,
      //   size: genreSet?.size,
      //   invoke: genreTotalMap.get(genre) || 0,
      //   lastMonth,
      // });

      return {
        name: genre,
        children: [], // 子数据留空
        // name_rev: genreTotalMap.get(genre) || 0,
        name_rev: findNameRev || 0,
      };
    });

  const sortedDates = Array.from(dateMap.keys()).sort();
  const allGenres = Array.from(genreSet);

  const topGenreRevDaily = sortedDates.map((date) => {
    const dailyData = dateMap.get(date)!;
    const revTotal = Array.from(dailyData.values()).reduce((sum, val) => sum + val, 0);

    return {
      date,
      rev_total: revTotal,
      name_rev: allGenres.map((genre) => ({
        name: genre,
        rev: dailyData.get(genre) || 0,
      })),
    };
  });

  return {
    market_top_genre: marketTopGenre,
    top_genre_rev_daily: topGenreRevDaily,
    // rev_total: Array.from(genreTotalMap.values()).reduce((sum, val) => sum + val, 0),
    rev_total: topGenreRevDaily?.[topGenreRevDaily?.length - 1]?.rev_total,
    // start_date: sortedDates[0],
    start_date: sortedDates[sortedDates.length - 1],
    end_date: sortedDates[sortedDates.length - 1],
    init: 1,
  };
}

// 安全访问可能为 null/undefined 的属性，并转为数字类型
export const safeNumberDiff = ({ preVal, curVal }) => {
  const pre = Number(preVal ?? 0);
  const cur = Number(curVal ?? 0);

  const result = pre - cur;

  return typeof result === 'number' && !Number.isNaN(result) ? result : 0;
};

// 转换新接口参数
export const changeParamsMetricList = (params: any, dataTag: string, isByDate: boolean = false) => {
  // console.debug('changeParamsMetricListchangeParamsMetricList', params)
  let orderMetric = '';
  const order = params?.order ?? 'desc';
  const groupBy = [];
  const groupByTop = [];
  let orderByTop: any = [];
  let newParams = {
    granularity: params.granularity,
    page: params.page,
    page_size: params.page_size,
    start_date: params.start_date,
    end_date: params.end_date,
    markets: Array.isArray(params?.markets) ? params?.markets : [params?.market],
    entity_type: params?.entity_type,
    top: {},
    filter: params?.filter || {},
    // order_by: [`${order}`],
    // order_by: [`${orderMetric} ${order}`],
  } as any;

  if (dataTag === 'operation') {
    groupBy.push('market');
    groupByTop.push('market');
    orderMetric = 'date';
    newParams = {
      ...newParams,
      metrics: ['mscience__digitalRevenue', 'npd__revenue'],
      order_by: [`${orderMetric} ${order}`, 'date desc'],
    };
    if (isByDate) {
      newParams = {
        ...newParams,
        order_by: ['market desc'],
      };
    }
    orderByTop = ['mscience__digitalRevenue desc'];
  }
  if (dataTag === 'games') {
    groupBy.push('game_id');
    groupByTop.push('game_id');
    orderMetric = 'mscience__digitalRevenue';
    newParams = {
      ...newParams,
      metrics: ['mscience__digitalRevenue', 'npd__revenue', 'newzoo__mau'],
      order_by: [`${orderMetric} ${order}`, 'date desc'],
      use_custom_fields: [
        'entity_name',
        'publisher',
        'publisher_country_abbre',
        'publisher_country_name_en',
        'parent_publisher',
        'genre',
        'sub_genre',
        'iegg_genre',
        'iegg_sub_genre',
        'sensortower_genre',
        'sensortower_sub_genre',
        'is_special_release_time',
        'release_time',
        'release_time_en',
        'release_time_cn',
        'sensortower_tag',
        'country_abbre',
        'country_name_en',
        'country_name_cn',
        'publisher_addr',
        'publisher_addr_full_name',
      ],
    };

    if (isByDate) {
      newParams = {
        ...newParams,
        order_by: ['game_id desc'],
      };
    }
    orderByTop = ['mscience__digitalRevenue desc'];
  }
  if (dataTag === 'main_genres') {
    groupBy.push(...['genre']);
    groupByTop.push(...['genre']);
    orderMetric = 'mscience__digitalRevenue';
    newParams = {
      ...newParams,
      order_by: [`${orderMetric} ${order}`, 'date desc'],
      metrics: ['mscience__digitalRevenue', 'npd__revenue', 'mscience__digitalRevenue_share', 'npd__revenue_share'],
    };
    if (isByDate) {
      newParams = {
        ...newParams,
        order_by: ['genre desc'],
      };
    }
    orderByTop = ['mscience__digitalRevenue desc'];
  }
  if (dataTag === 'sub_genres') {
    groupBy.push(...['genre', 'sub_genre']);
    groupByTop.push(...['genre', 'sub_genre']);
    orderMetric = 'mscience__digitalRevenue';
    newParams = {
      ...newParams,
      order_by: [`${orderMetric} ${order}`, 'date desc'],
      metrics: ['mscience__digitalRevenue', 'npd__revenue'],
    };
    if (isByDate) {
      newParams = {
        ...newParams,
        order_by: ['genre desc'],
      };
    }
    orderByTop = ['mscience__digitalRevenue desc'];
  }
  if (dataTag === 'companies') {
    groupBy.push('company_id');
    groupByTop.push('company_id');
    orderMetric = 'mscience__digitalRevenue';
    newParams = {
      ...newParams,
      metrics: ['mscience__digitalRevenue', 'npd__revenue'],
      use_entity_type: 'company',
      use_custom_fields: ['name', 'location_identifiers_city', 'location_identifiers_country'],
      entity_type: 'company',
      order_by: [`${orderMetric} ${order}`, 'date desc'],
      filter: {},
    };

    if (isByDate) {
      newParams = {
        ...newParams,
        order_by: ['company_id desc'],
      };
    }
    orderByTop = ['mscience__digitalRevenue desc'];
  }
  if (isByDate) {
    groupBy.push('date');
  }
  if (!newParams?.end_date) {
    newParams = {
      ...newParams,
      check_metrics: ['mscience__digitalRevenue'],
    };
  }
  newParams = {
    ...newParams,
    group_by: groupBy,
  };
  if (dataTag !== 'operation' && params.select_top !== 9999999) {
    newParams = {
      ...newParams,
      top: {
        group_by: groupByTop,
        order_by: orderByTop,
        size: params.select_top || params.page_size,
      },
    };
  } else {
    newParams = {
      ...newParams,
      page_size: 100000,
    };
  }

  return newParams;
};


// 转换新接口,返回数据格式
// export const changeResDatasMetricList = (resData: any) => {
//   console.debug('changeResDatasMetricList', resData)

// };
